<template>
  <v-container class="px-12">
    <v-row>
      <v-col cols="12" lg="12">
        <v-row>
          <v-col cols="12">
            <v-img
              :src="getImage(computedData.logo)"
              height="350px"
              contain
              v-if="computedData.logo"
            ></v-img>
          </v-col>
          <v-col cols="12">
            <span class="dialog-content-text">
              {{ computedData.description }}
            </span>
          </v-col>
          <v-col cols="12">
            <span
              ><b>
                {{ $t("texts.volunteeringBeginningDate") }}
              </b>
            </span>
            <span class="dialog-content-text">
              {{ formatDate(computedData.dates.realizationStart) }}
            </span>
          </v-col>
          <v-col cols="12">
            <span
              ><b>
                {{ $t("texts.donationEndDate") }}
              </b>
            </span>
            <span class="dialog-content-text">
              {{ formatDate(computedData.dates.realizationEnd) }}
            </span>
          </v-col>
          <div v-if="isMonetaryDonation">
            <v-col cols="12">
              <span
                ><b>
                  {{ $t("texts.entity") }}
                </b>
              </span>
              <span class="dialog-content-text">
                {{ computedData.entity }}
              </span>
            </v-col>
            <v-col cols="12">
              <span
                ><b>
                  {{ $t("texts.iban") }}
                </b>
              </span>
              <span class="dialog-content-text">
                {{ computedData.iban }}
              </span>
            </v-col>
          </div>
          <v-col cols="12" v-if="computedData.regulation">
            <span
              ><b>
                {{ $t("texts.regulation") }}
              </b>
            </span>
            <p>
              {{
                $t("texts.regulationText", {
                  program: computedData.programName
                })
              }}
              <a
                color="primary"
                v-if="computedData.regulation !== null"
                @click="openRegulation(computedData.regulation)"
              >
                {{ $t("texts.here") }}
              </a>
            </p>
          </v-col>
          <v-col cols="12" v-if="canSeeDonations()">
            <span>
              <b>
                {{ $t("texts.donationsList") }}
              </b>
            </span>
            <p>
              {{ $t("texts.donationListText") }}
              <a color="primary" @click.stop="seeDonationsItem(computedData)">
                {{ $t("texts.here") }}
              </a>
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { parseISO } from "date-fns";

export default {
  name: "donation-detail-card",

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  methods: {
    /**
     * Format the date
     * @param {date} value - The date to format.
     * @public
     */
    formatDate(value) {
      return value ? this.$d(parseISO(value), "short") : "";
    },

    getImage(image) {
      if (!image) return;
      return process.env.VUE_APP_API_BASE_URI + "/donations/" + image;
    },

    /**
     * Open pdf
     * @param {url} link - Link to open pdf.
     * @public
     */
    openRegulation(link) {
      let openLink = process.env.VUE_APP_API_BASE_URI + "/donations/" + link;
      window.open(openLink, "_blank");
    },

    /**
     * Check if exist any donations approved
     * @public
     */
    canSeeDonations() {
      if (this.computedData.donations.length > 0) {
        const isApproved = this.computedData.donations.some(
          donation => donation.approved === true
        );
        return isApproved;
      } else {
        return false;
      }
    },

    /**
     * Download donations
     * @public
     */
    seeDonationsItem(item) {
      let url = this.$config.api.route.downloadPDF;
      url = url.replace(":id", item._id);
      this.$api({
        url: url,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.programName + ".pdf");
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  computed: {
    /**
     * Check if volunteering has comments or interest areas.
     * @public
     */
    computedData() {
      if (this.data === null || Object.keys(this.data).length === 0) {
        return {};
      }
      let data = this.data;
      return data;
    },
    /**
     * Check if the donation is monetary
     * @public
     */
    isMonetaryDonation() {
      if (this.data === null || Object.keys(this.data).length === 0) {
        return false;
      }
      return this.data.type.find(e => e === 1) ? true : false;
    }
  }
};
</script>
